
import _ from 'lodash'
import '../../../css/svdreact.css'
import SRCarousel from './SRCarousel'



import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner';



const React = require('react')




class CliFareTerrainContainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this



    }



    getAppDetails(paramQSpaceId) {
        
        let paramOb = {
            paramQSpaceId: paramQSpaceId
        }
        


        let ids = paramQSpaceId ? paramQSpaceId : "xxx"
        let sv_esquery_data = {
            "docId": ["5"],
            "hsetname": ids
        }

        let sojPostRq = {
            "docId": [],
            "hsetname": paramQSpaceId ? paramQSpaceId : "xxx"
        }
        sojPostRq.docId.push(ids)
        this.props.cliAndImagesCruisePaginate1HotelById(sojPostRq, sv_esquery_data);


    }
    getAppDetailsUseCookie(paramQSpaceObWithId) {
        let paramQSpaceId = paramQSpaceObWithId.id

        let paramOb = {
            paramQSpaceId: paramQSpaceId
        }
       

        /*
    { my_esqueryText: "San Diego", STARTDATE: "2025-08-14", ENDDATE: "2025-08-15", time_zone: "+01:00" }
        */
        let ids = paramQSpaceId ? paramQSpaceId : "xxx"
        let sv_esquery_data = {
            "docId": ["5"],
            "hsetname": ids
        }

        let sojPostRq = {
            "docId": [],
            "hsetname": paramQSpaceId ? paramQSpaceId : "xxx"
        }
        sojPostRq.docId.push(ids)
        this.props.cliAndImagesFarelById(sojPostRq, sv_esquery_data);


    }
    componentWillMount() {
       
        let id;
        if (this.props.svparams) {
            id = this.props.svparams

        } else {
            
            id = 1;
        }

        this.getAppDetailsUseCookie(id)

    }



    getChildContainers() {

        let cruise = null, data = [], hosts = [], dbs = [], sojourns = [], my_data = [], fgtree = []


        let cabincategories = []
        //let svr_tablets = ["http://localhost:8080/images/soj2.jpg", "http://localhost:8080/images/soj3.jpg", "http://localhost:8080/images/soj4.jpg", "http://localhost:8080/images/soj5.jpg", "http://localhost:8080/images/soj6.jpg" ]
        if (this.props.cruiseFareView.my_data && (this.props.cruiseFareView.my_data.length > 0)) {
            my_data = this.props.cruiseFareView.my_data
           
            cabincategories = my_data
        }


        let plot = 'RESULT'
        const lastestUpdateDate = 'Data Refresh Daily'
        return (<div >
            <header className="svr-header1">
                <h1> Cruise  Staterooms And Prices</h1>
            </header>

            <div className="col-md-12" id="svsr1">
                <SRCarousel cabincategories={cabincategories}></SRCarousel>
            </div>

        </div>

        )

    }




    getHotelDetailBodyContainer_soj(my_data) {
        const lastestUpdateDate = 'Data Refresh Daily'
        if (this.props.error && (this.props.error === true)) {
            
            let errob = {
                "timestamp": "2015-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "FlyServer Error",
                "message": "No Resulst Found.Please refinse search and try again",
                "path": "/kk/svaddressDetailPost"
            }
            let today_dt = new Date()
            errob["timestamp"] = today_dt
            return (
                <div >

                    <div style={{ paddingTop: '10px' }}>
                        <ErrorCom closecbParent={this.closecbParent} errob={errob} ></ErrorCom>
                    </div>


                </div>
            )

        } else if (this.props.loading && (this.props.loading === true)) {
            return (

                <div >
                    <h3>Spinner*****</h3>
                    <div style={{ paddingTop: '10px' }}>


                        <SVAbodeSpinner />
                    </div>


                </div>


            )

        }


        return (
            <noop>



                {this.getChildContainers()}


            </noop>

        )
    }


    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title } = this

        /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */

      
        const { my_data } = this.props

        return (


            <div className="col-md-12">

                {
                    this.getHotelDetailBodyContainer_soj(my_data)
                }


            </div>
        )

    }

}

export default CliFareTerrainContainer